export default __webpack_public_path__ + "static/media/spin4.5099398d.png";